import React, { PureComponent } from 'react'
import settingsTypes from '../../../helpers/enums/settingsTypes'
import TeacherSettings from './TeacherSettings'
import NoSettings from './NoSettings'
import { IGameSettings } from '../../../helpers/data/gameSettings'

interface ISettingsProps {
	onSettingsSubmit: (settings: any) => void
	settings: IGameSettings
}

const SettingsComponents = {
	[settingsTypes.NONE]: NoSettings,
	[settingsTypes.TEACHER]: TeacherSettings,
	[settingsTypes.STUDENT]: NoSettings,
}

class SplashSettings extends PureComponent<ISettingsProps> {
	render() {
		const SettingsComponent = SettingsComponents[this.props.settings.type]

		return (
			<SettingsComponent
				settings={this.props.settings}
				onSettingsSubmit={this.props.onSettingsSubmit}
			/>
		)
	}
}

export default SplashSettings
